import React, { ReactNode, useState } from 'react';
import { Dropdown } from 'antd';

import { getTranslateFunc } from '../../../../utils/stringUtil';
import IbIcon from '../../../../components/common/IbIcon';
import IbTypography from '../../../../components/common/IbTypography';
import IbTooltip from '../../../../components/common/IbTooltip';

import './index.less';

import {
  BUTTON_CLASS_NAME,
  MAIN_CLASS_NAME,
  OVERLAY_CLASS_NAME,
  SCROLL_CLASS_NAME,
  TOOLTIP_MOUSE_DELAY,
} from './const';

export interface IFolderItemsProps {
  group: string;
  items: unknown[];
  onRender?: (item: unknown) => ReactNode;
}

const FolderItems: React.FC<IFolderItemsProps> = ({ group, items, onRender }) => {
  const [opened, setOpened] = useState(false);

  const translate = getTranslateFunc(`Folder: Items: ${group}:`);

  const onOverlayClick = () => {
    setOpened(false);
  };

  const onVisibleChange = (visible: boolean) => {
    setOpened(items.length ? visible : false);
  };

  const getTitle = (): string => {
    return translate('Count', { count: items.length });
  };

  const renderTitle = () => {
    const title = getTitle();
    return (
      <IbTooltip mouseEnterDelay={TOOLTIP_MOUSE_DELAY} title={title}>
        <IbTypography>
          <IbTypography.Paragraph type="secondary">{title}</IbTypography.Paragraph>
        </IbTypography>
      </IbTooltip>
    );
  };

  const renderArrow = () => {
    const iconName = opened ? 'up' : 'down';
    return <IbIcon iconName={iconName} size={20} />;
  };

  const renderEmpty = () => {
    const title = getTitle();
    return (
      <IbTooltip mouseEnterDelay={TOOLTIP_MOUSE_DELAY} title={title}>
        <IbTypography>
          <IbTypography.Paragraph disabled type="secondary">
            {title}
          </IbTypography.Paragraph>
        </IbTypography>
      </IbTooltip>
    );
  };

  const renderButton = () => {
    return (
      <button className={BUTTON_CLASS_NAME}>
        {renderTitle()}
        {renderArrow()}
      </button>
    );
  };

  const renderOverlay = () => {
    return (
      <div className={OVERLAY_CLASS_NAME} onClick={onOverlayClick}>
        <div className={SCROLL_CLASS_NAME}>{items.map((item) => onRender?.(item))}</div>
      </div>
    );
  };

  if (!items.length) {
    return <div className={MAIN_CLASS_NAME}>{renderEmpty()}</div>;
  }

  return (
    <Dropdown
      className={MAIN_CLASS_NAME}
      overlay={renderOverlay()}
      trigger={['click']}
      onVisibleChange={onVisibleChange}
    >
      {renderButton()}
    </Dropdown>
  );
};

export default FolderItems;
